import React from 'react';
import { string } from 'prop-types';

import { UPDOX_TAGLINE } from '../../constants/AppConstants';
import Logo from '../Logo';

import cx from 'classnames';
import s from './Footer.css';


const Footer = ({...props}) => {

    const renderPartnerLogo = () => {
        if (props.partnerLogoUrl === 'sharecaretelehealth') {
            return (
                <div className={s.flex}>
                    <img id='sharecaretelehealthLogo' className={s.image} src={require('./logos/sharecare/Sharecare-logo-horz white RGB.png')} alt="sharecaretelehealth logo" />
                </div>
            );
        }
    };

    return(
        <nav className={s.component}>
            {renderPartnerLogo()}
            <span className={props.partnerLogoUrl ? s.poweredByWithPartnerLogo : s.poweredBy}>powered by </span>
            <Logo
                className={cx(s.updoxLogo, props.dark ? s.dark : '', props.partnerLogoUrl ? s.updoxLogoWithPartnerLogo : s.updoxLogo)}
                iconTitle={UPDOX_TAGLINE}
                id="updoxLogo"
            />
        </nav>
    );

};

Footer.propTypes = {
    partnerLogoUrl: string,
};

export default Footer;
